const HPValues = [
	{
		Normal: {
			RedHP: 796347,
			Ratio: [1, 2.25, 3.5, 7],
		},
		Hard: {
			RedHP: 1274155,
			Ratio: [1, 2.25, 3.5, 7],
		},
		Challenging: {
			RedHP: 1831598,
			Ratio: [1, 2.25, 3.5, 7],
		},
		Heroic: {
			RedHP: 2588127,
			Ratio: [1, 2.25, 3.5, 7],
		},
	},
	{
		Normal: {
			RedHP: 971543,
			Ratio: [1, 2.31, 3.73, 8.03],
		},
		Hard: {
			RedHP: 1554469,
			Ratio: [1, 2.31, 3.73, 8.03],
		},
		Challenging: {
			RedHP: 2234550,
			Ratio: [1, 2.31, 3.73, 8.03],
		},
		Heroic: {
			RedHP: 3157515,
			Ratio: [1, 2.31, 3.73, 8.03],
		},
	},
	{
		Normal: {
			RedHP: 1186557,
			Ratio: [1, 2.38, 3.97, 9.21],
		},
		Hard: {
			RedHP: 1898491,
			Ratio: [1, 2.38, 3.97, 9.21],
		},
		Challenging: {
			RedHP: 2729081,
			Ratio: [1, 2.38, 3.97, 9.21],
		},
		Heroic: {
			RedHP: 3856309,
			Ratio: [1, 2.38, 3.97, 9.21],
		},
	},
	{
		Normal: {
			RedHP: 1449352,
			Ratio: [1, 2.44, 4.23, 10.63],
		},
		Hard: {
			RedHP: 2318962,
			Ratio: [1, 2.44, 4.23, 10.63],
		},
		Challenging: {
			RedHP: 3333508,
			Ratio: [1, 2.44, 4.23, 10.63],
		},
		Heroic: {
			RedHP: 4710392,
			Ratio: [1, 2.44, 4.23, 10.63],
		},
	},
];

export default HPValues;
